import React from 'react'
import Header from '../../User/layouts/Header';
import '../../User/styles/pages/profile.scss';
import { Typography, Button } from '@mui/material';
import WhatsApp from "../../User/components/WhatsApp";
import { useNavigate } from 'react-router-dom';
import applogo from "../assets/logo.svg";
import CancelIcon from "@mui/icons-material/Cancel";

const ThankYou = () => {
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Header />
      <section className='thankyou-page'>
        <img className='thankyou-banner' src={applogo} alt='thankyou' />
        <Typography variant='h4' className="failed-title">
          Payment <span>Failed!</span>
        </Typography>
        {/* <Typography variant='h4'>Thank <span>You</span></Typography> */}
        <CancelIcon className='failed-icon' />
        <Button className='goback-btn' onClick={() => navigate('/home')}>Go Back</Button>
      </section>
      <WhatsApp />
    </React.Fragment>
  )
}

export default ThankYou
 